import { getStaticImageSrc } from '#/utils/getImageSrc';

// We have to use functions because the config is not always set at
// this point, because it's global scope.
export const ActionOppsIconSrcByName = {
  nycparks: () =>
    getStaticImageSrc('icons/action-opps/action-opps-nycparks.svg'),
  golden: () => getStaticImageSrc('icons/action-opps/action-opps-golden.png'),
} as const;
